var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"vertical-align":"middle","text-align":"center"}},[(_vm.state.error)?_c('div',{staticStyle:{"display":"inline-block"}},[_c('div',[_vm._v("SSO login failed.")]),_c('button',[_vm._v("Retry")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }